// NOTE/TODO (PENDING WEBOPS-1789):
// THE NAVIGATION IS NOT FULLY ACCESSIBLE,
// BUT THIS JS MAKES IT A LITTLE MORE ACCESSIBLE THAN IT WOULD BE OTHERWISE
const siteHeader = document.getElementById('site-header');
const siteHeaderNavigation = document.getElementById('site-header-navigation');
const siteHeaderMenuButton = document.getElementById('site-header-menu-button');
const siteHeaderSearch = document.getElementById('site-header-search');
const siteHeaderSearchButton = document.getElementById('site-header-search-button');
const siteHeaderSearchCloseButton = document.getElementById('site-header-search-close-button');
const siteHeaderSearchInput = document.getElementById('site-header-search-input');
// When non-mobile styles/functionality is used
const nonMobileWidth = 721;

if (siteHeader && siteHeaderNavigation && siteHeaderMenuButton && siteHeaderSearch && siteHeaderSearchButton && siteHeaderSearchCloseButton && siteHeaderSearchInput) {

	// Handle the various toggle on/off from clicking menu button
	siteHeaderMenuButton.addEventListener('click', event => {
		closeSearch();
		toggleMenu();
	});

	siteHeaderSearchButton.addEventListener('click', event => {
		closeMenu();

		if (siteHeaderSearchButton.getAttribute('type') === 'button') {
			// Prevent the search submitting on the initial click
			event.preventDefault();
			openSearch();
		}
	});

	siteHeaderSearchCloseButton.addEventListener('click', event => {
		closeMenu();
		closeSearch();
	});

	const siteHeaderRow = siteHeader.querySelector('.row');
	const siteHeaderNavigationList = siteHeader.querySelector('.site-header-navigation-list');
	const menuParentItems = siteHeader.querySelectorAll('.menu-parent-item');

	if (siteHeaderRow && siteHeaderNavigationList && menuParentItems.length > 0) {

		const parentItemOpenClass = 'menu-top-level-item--open';
		const fullMenuClass = 'full-menu';
		const partialMenuClass = 'partial-menu';
		const outerSubMenus = siteHeader.querySelectorAll('.sub-menu-depth-0');

		// Only loop through top-level menu items with sub-links/sub-menus
		for (const item of menuParentItems) {

			const useFullMenu = shouldUseFullMenu(item);

			// If it has "grand children" links it uses the "full menu" style,
			// otherwise it uses the "partial menu" style
			const menuTypeClass = useFullMenu ? fullMenuClass : partialMenuClass;

			// The outer sub-menu that either holds heading links and multiple sub-menus ("full menu") or just links ("partial menu")
			const outerSubMenu = getItemSubMenu(item);

			// Some dynamic style adjustments need to be made when mousing over the parent items, such as:
			// - Setting the "full menu" width to fill out the rest of the site navigation width
			// - Equalizing the height of the main navigation list and the sub-menu (both for "full" and "partial menu" types)
			// - Adjusting the width of the parent site navigation element so that its box-shadow shows around the child elements
			item.addEventListener('mouseenter', event => {
				if (window.innerWidth >= nonMobileWidth) {
					closeSubMenus(false);
					openSubMenu(item, outerSubMenu, useFullMenu, menuTypeClass);
				}
			});

			// Remove any special classes or widths/heights	and fall back to default styles
			item.addEventListener('mouseleave', event => {

				if (window.innerWidth >= nonMobileWidth && getCurrentlyOpenedItem()) {

					// During mouseleave events, the relatedTarget is the element the mouse lands on
					// So only close the navigation when the mouse does not enter a new sub-menu trigger (avoids some ugly transitioning/buggy shadows)
					let closeBecauseOfRelatedTarget = true;

					if (event.relatedTarget) {
						const classList = event.relatedTarget.classList;
						closeBecauseOfRelatedTarget = !classList.contains('menu-parent-item') && !classList.contains('menu-parent-heading');
					}

					closeSubMenus(closeBecauseOfRelatedTarget);
				}
			});

			item.addEventListener('click', event => {

				// Don't toggle sub menu when clicking on inner links
				if (event.target.classList.contains('menu-parent-heading')) {
					toggleSubMenu(item, outerSubMenu, useFullMenu, menuTypeClass, event);
				}
			});

			item.addEventListener('keydown', event => {

				// Don't toggle sub menu when activating inner links
				if (event.key === 'Enter' && event.target.classList.contains('menu-parent-item')) {
					toggleSubMenu(item, outerSubMenu, useFullMenu, menuTypeClass, event);
				}
			});
		}

		function openSearch() {
			siteHeaderSearchButton.setAttribute('type', 'submit');
			siteHeaderSearchButton.setAttribute('aria-label', 'Submit search');
			siteHeaderSearch.classList.add('site-header-search--open');
		}

		function closeSearch() {
			siteHeaderSearch.classList.remove('site-header-search--open');
			siteHeaderSearchButton.setAttribute('type', 'button');
			siteHeaderSearchButton.setAttribute('aria-label', 'Open search form');
		}

		function getCurrentlyOpenedItems() {

			let openItems = [];

			for (const item of menuParentItems) {

				if (subMenuOpened(item)) {
					openItems.push(item);
				}
			}

			return openItems;
		}

		function getCurrentlyOpenedItem() {

			for (const item of menuParentItems) {

				if (subMenuOpened(item)) {
					return item;
				}
			}

			return null;
		}

		function getItemSubMenu(item) {
			return item.querySelector('.sub-menu-depth-0');
		}

		function shouldUseFullMenu(item) {
			const grandChildren = item.querySelectorAll('.menu-item-has-children');

			return grandChildren.length > 0;
		}

		function subMenuOpened(item) {
			return item.classList.contains(parentItemOpenClass);
		}

		function closeSubMenus(closeSiteHeaderNavigation = true) {

			const openItems = getCurrentlyOpenedItems();

			for (const openItem of openItems) {
				openItem.classList.remove(parentItemOpenClass);
				openItem.removeAttribute('aria-expanded');
				const subMenu = getItemSubMenu(openItem);

				if (window.innerWidth >= nonMobileWidth) {

					if (closeSiteHeaderNavigation) {
						slideLeft(siteHeaderNavigation);
					}

					slideLeft(subMenu);
					subMenu.style.opacity = '0';
					subMenu.style.height = '';
				} else {
					slideUp(subMenu);
				}

				subMenu.setAttribute('aria-hidden', 'true');
				siteHeaderNavigation.classList.remove(fullMenuClass, partialMenuClass);
			}
		}

		function toggleSubMenu(item, outerSubMenu, useFullMenu, menuTypeClass, event) {

			// Get its current opened status before closing/resetting everything
			const opened = subMenuOpened(item);
			const openedItem = getCurrentlyOpenedItem();

			// There is currently an opened item
			if (openedItem) {
				// If the target item is already opened, we want to close the navigation
				// Otherwise we keep the navigation open (and just the sub menu will change) to avoid some weird shadow/transition behaviors
				closeSubMenus(openedItem === item);
			}

			// It was not opened, so open it
			if (!opened) {
				openSubMenu(item, outerSubMenu, useFullMenu, menuTypeClass);
			}
		}

		function openSubMenu(item, outerSubMenu, useFullMenu, menuTypeClass) {
			siteHeaderNavigation.classList.add(menuTypeClass);
			outerSubMenu.setAttribute('aria-hidden', 'false');
			item.setAttribute('aria-expanded', 'true');
			item.classList.add(parentItemOpenClass);
			item.querySelector('a').focus();

			// Only run this code when using non-mobile styles
			if (window.innerWidth >= nonMobileWidth) {
				handleWidthLogic(outerSubMenu, useFullMenu);

				setTimeout(() => {
					handleHeightLogic(outerSubMenu);
				}, 201);
			} else {
				slideDown(outerSubMenu);
			}
		}

		function openMenu() {
			siteHeader.classList.add('site-header--open');
			siteHeaderMenuButton.classList.add('menu-button--open');
			siteHeaderMenuButton.setAttribute('aria-expanded', 'true');
			siteHeaderNavigation.classList.add('site-header-navigation--open');
			siteHeaderNavigation.setAttribute('aria-hidden', 'false');

			slideDown(siteHeaderNavigation);
		}

		function closeMenu() {
			slideUp(siteHeaderNavigation);
			siteHeader.classList.remove('site-header--open');
			siteHeaderMenuButton.classList.remove('menu-button--open');
			siteHeaderMenuButton.removeAttribute('aria-expanded');
			siteHeaderNavigation.classList.remove('site-header-navigation--open');
			siteHeaderNavigation.setAttribute('aria-hidden', 'true');
			siteHeaderNavigationList.style.height = '';

			if (getCurrentlyOpenedItem()) {
				closeSubMenus();
			}
		}

		function toggleMenu() {

			// Menu is opened, close it
			if (siteHeader.classList.contains('site-header--open')) {
				closeMenu();
			} else {
				openMenu();
			}
		}

		function handleWidthLogic(outerSubMenu, useFullMenu) {

			let width = 0;

			// When it is a full menu:
			// - In the CSS, the site navigation uses roughly width: 100%; (some padding offsets) to match the width of the container (part of design)
			// - The site navigation is divided up by the main navigation list and the sub-menu (which is actually a child element of the main navigation list)
			// - This code makes it so the sub-menu width fills whatever space is left over from the main navigation list
			if (useFullMenu) {
				const rowWidth = siteHeaderRow.offsetWidth;
				const navigationListWidth = siteHeaderNavigationList.offsetWidth;
				siteHeaderNavigation.style.width = "";

				// The minus 15 comes from offsetting the 7.5px left/right padding
				width = rowWidth - navigationListWidth - 15;
				slideRight(outerSubMenu, 200, width);
			}
			// The partial menu is not full width, so we can't just use width: 100%; for the site navigation
			// The site navigation parent element needs to match the width of its main navigation list + the partial menu in order for the box-shadow to look right
			else {
					const navigationListWidth = siteHeaderNavigationList.offsetWidth;
					const outerSubMenuWidth = outerSubMenu.offsetWidth;

					width = navigationListWidth + outerSubMenuWidth;
					slideRight(siteHeaderNavigation, 200, width);
				}
		}

		function handleHeightLogic(outerSubMenu) {
			siteHeaderNavigationList.style.height = '';
			outerSubMenu.style.height = '';
			outerSubMenu.style.opacity = '0';

			const navigationListHeight = siteHeaderNavigationList.offsetHeight;
			const outerSubMenuHeight = outerSubMenu.offsetHeight;

			// Use the tallest height
			const height = Math.max(navigationListHeight, outerSubMenuHeight);

			// Make both elements as tall as the tallest element
			siteHeaderNavigationList.style.height = convertPixelsToRem(height);
			outerSubMenu.style.height = convertPixelsToRem(height);
			outerSubMenu.style.opacity = '1';
		}

		window.addEventListener('resize', event => {

			if (window.innerWidth >= nonMobileWidth) {
				const item = getCurrentlyOpenedItem();

				if (item) {
					const outerSubMenu = getItemSubMenu(item);
					handleWidthLogic(outerSubMenu, shouldUseFullMenu(item));

					setTimeout(() => {
						handleHeightLogic(outerSubMenu);
					}, 201);
				}
			} else {
				siteHeaderNavigation.style.width = '';
				siteHeaderNavigationList.style.height = '';

				for (const outerSubMenu of outerSubMenus) {
					outerSubMenu.style.width = '';
					outerSubMenu.style.height = '';
				}
			}
		});

		function convertPixelsToRem(px) {
			return 1 / parseFloat(getComputedStyle(document.documentElement).fontSize) * px + 'rem';
		}

		// TODO (EVENTUALLY): Try cleaning up all these slide transitions / simplify their logic if possible
		// Plus try and simplify/redo the height/width logic to be less messy, some requested features/behaviors
		// later on caused some unexpected spaghetti code to get working without re-doing lots of stuff / time crunch, worth revisiting later
		function slideUp(target, duration = 200) {
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.boxSizing = 'border-box';
			target.style.height = target.offsetHeight + 'px';
			// Forces a reflow/recalculation of the element's layout
			target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;

			window.setTimeout(() => {
				target.style.removeProperty('display');
				target.style.removeProperty('height');
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
				target.style.removeProperty('opacity');
			}, duration);
		}

		function slideDown(target, duration = 200) {

			target.style.removeProperty('display');
			let display = window.getComputedStyle(target).display;
			if (display === 'none') {
				display = 'block';
			}
			target.style.display = display;
			let height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			// Forces a reflow/recalculation of the element's layout
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + 'ms';
			target.style.opacity = '1';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');

			window.setTimeout(() => {
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}

		function slideToggleVertical(target, duration = 200) {

			if (window.getComputedStyle(target).display === 'none') {
				return slideDown(target, duration);
			} else {
				return slideUp(target, duration);
			}
		}

		function slideRight(target, duration = 200, customWidth = null) {
			target.style.overflow = 'hidden';
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = 'width, margin, padding, opacity';
			target.style.transitionDuration = duration + 'ms';

			// Check if the target is initially hidden (display: none)
			const wasHidden = window.getComputedStyle(target).display === 'none';

			// Temporarily show the element and get its initial width
			if (wasHidden) {
				target.style.display = 'block';
			}

			const currentWidth = customWidth || target.offsetWidth;

			target.style.width = 0;
			target.offsetWidth; // Force layout recalculation
			target.classList.add('transitioning');
			target.style.width = convertPixelsToRem(currentWidth);

			window.setTimeout(() => {
				// If a custom width was passed, keep it
				// Otherwise fall back on auto
				if (!customWidth) {
					target.style.removeProperty('width');
				}
				target.style.removeProperty('padding-left');
				target.style.removeProperty('padding-right');
				target.style.removeProperty('margin-left');
				target.style.removeProperty('margin-right');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
				target.style.removeProperty('display');
				target.style.removeProperty('white-space');
				target.classList.remove('transitioning');
			}, duration);
		}

		function slideLeft(target, duration = 200) {
			target.style.overflow = 'hidden';
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = 'width, margin, padding, opacity';
			target.style.transitionDuration = duration + 'ms';

			let display = window.getComputedStyle(target).display;
			if (display === 'none') {
				display = 'block';
			}
			target.style.display = display;

			target.style.width = 0;
			target.style.paddingLeft = 0;
			target.style.paddingRight = 0;
			target.style.marginLeft = 0;
			target.style.marginRight = 0;

			// Force layout recalculation
			target.offsetHeight;

			window.setTimeout(() => {
				target.style.removeProperty('padding-left');
				target.style.removeProperty('padding-right');
				target.style.removeProperty('margin-left');
				target.style.removeProperty('margin-right');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
				target.style.removeProperty('display');
				target.style.removeProperty('white-space');
				target.style.removeProperty('width');
				siteHeaderNavigationList.style.removeProperty('height');
			}, duration);
		}
	}
}